import { deepFreeze } from '../lib'

export const limitPercentage = 0.7
export const queryKeys = Object.freeze({
  userOrderByAccountNumber: 'userOrderByAccountNumber',
  positionByAccountNumber: 'positionByAccountNumber',
  listPositions: 'listPositions',
  listSubAccounts: 'listSubAccounts',
  listUserProfiles: 'listUserProfiles',
  accountInformationByAccountRequestStatus:
    'accountInformationByAccountRequestStatus',
  getOrder: 'getOrder',
  listDocumentUploads: 'listDocumentUploads',
  listDraftUserProfiles: 'listDraftUserProfiles',
  listExecutionReports: 'listExecutionReports',
  executionReportByExecTransType: 'executionReportByExecTransType',
  positionHistoryByAccountNumber: 'positionHistoryByAccountNumber',
  listForms: 'listForms',
  listAchRelationships: 'listAchRelationships',
  listMarginCallReports: 'listMarginCallReports',
  listDailyExerciseAssignmentFiles: 'listDailyExerciseAssignmentFiles',
  listNameBaseDumps: 'listNameBaseDumps',
  listTradeActivities: 'listTradeActivities',
  listOvernightBuyingPowers: 'listOvernightBuyingPowers',
  listElectronicCommunications: 'listElectronicCommunications',
  listPositionBreakouts: 'listPositionBreakouts',
  listConsolidatedCashActivityReports: 'listConsolidatedCashActivityReports',
  achDepositWithdrawalRequestByAccountNumber:
    'achDepositWithdrawalRequestByAccountNumber',
  userOrderByAccountNumberAndCreatedAt: 'userOrderByAccountNumberAndCreatedAt',
  userOrderByAccountNumberAndStatus: 'userOrderByAccountNumberAndStatus',
  userOrderByAccountNumberAndUpdatedDate:
    'userOrderByAccountNumberAndUpdatedDate',
  accountInformationByPrimaryOwner: 'accountInformationByPrimaryOwner',
})

export const tabIds = deepFreeze({
  watchList: { id: 'WatchlistWidget', label: 'Watchlist' },
  optionChain: {
    id: 'OptionChainWidget',
    label: 'Option Chain',
    component: 'OptionChain',
  },
  equityTrade: { id: 'EquityTradeWidget', label: 'Equity Trade' },
  orders: { id: 'OrdersClientWidget', label: 'Orders' },
  positionsNew: { id: 'PositionBrokerNew', label: 'PositionsNew' },
  positionHistory: { id: 'PositionHistoryWidget', label: 'Position History' },
  traderProfile: { id: 'PersonalInfoWidget', label: 'Trader Profile' },
  cashiering: { id: 'CashieringWidget', label: 'Cashiering' },
  onboarding: { id: 'OnboardingWidget', label: 'Onboarding' },
  groupTrade: { id: 'GroupTrade', label: 'Group Trade' },
})

export const mutationKeys = Object.freeze({
  createDraftUserProfile: 'createDraftUserProfile',
  updateDraftUserProfile: 'updateDraftUserProfile',
  deleteDraftUserProfile: 'deleteDraftUserProfile',
  updateUserProfile: 'updateUserProfile',
})
